// Copyright (c) 2018 Deere & Company

import CourierInfo, {getDefaultState as getDefaultCourierInfoState} from '@deere/cps-it.warranty-model-factory/lib/courier-info';
import ReturnStatus, {getDefaultState as getDefaultReturnStatusState} from '@deere/cps-it.warranty-model-factory/lib/return-status';
import File from '@deere/cps-it.warranty-model-factory/lib/file';
import t from 'tcomb';

const PictureRequestForm = t.struct({
    courierInfo: CourierInfo,
    files: t.list(File, 'Files'),
    returnStatus: ReturnStatus
}, 'PictureRequestForm');

export const getDefaultState = () => new PictureRequestForm({
    courierInfo: getDefaultCourierInfoState(),
    files: [],
    returnStatus: getDefaultReturnStatusState()
});

export default PictureRequestForm;



// WEBPACK FOOTER //
// ./src/part-requests/request-details/state/picture-request-form.js